const IssueViewAgentPanelEmpty = () => {
	return null;
};

export default IssueViewAgentPanelEmpty;
